export default __webpack_public_path__ + "static/why_1-059392c154ab8da61bf719f4893e1eee.gif";